// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-462c8810\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DocumentCategoryPicker.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("38ae9d90", content, true);


//////////////////
// WEBPACK FOOTER
// /~/vue-style-loader!/~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-462c8810","scoped":true,"hasInlineConfig":false}!/~/sass-loader/lib/loader.js!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/components/DocumentCategoryPicker.vue
// module id = 427
// module chunks = 0